import { ProjectDetailPage } from './ProjectDetailPage';
import { withProjectDetailPage } from './withProjectDetailPage';

const ConnectedProjectDetailPage = withProjectDetailPage(ProjectDetailPage);

export { ConnectedProjectDetailPage as ProjectDetailPage };
